import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FolderIcon from "@mui/icons-material/Folder";
import {
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useQuery } from "@tanstack/react-query";
import React, { useRef, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useFormContext, Controller } from "react-hook-form";

import { ProjectSelectPropInterface } from "./ProjectSelect";

import { listProject } from "@/api";
import { CreateTaskInterface } from "@/types/task";

export const StyledTypography = styled(Typography)(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "200px",
}));


export const ProjectSelect: React.FC<ProjectSelectPropInterface> = ({ project }) => {
  const { control } = useFormContext<CreateTaskInterface>();
  const addProductRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpenState = () => setIsOpen(!isOpen);

  const { isLoading: isLoadingProjectList, data: projects } = useQuery({
    queryKey: ["list-projects"],
    queryFn: async () => await listProject(),
  });

  return (
    <Fragment>
      <Button
        ref={addProductRef}
        endIcon={<ArrowDropDownIcon />}
        onClick={toggleOpenState}
        variant="outlined"
        color="primary"
        startIcon={<FolderIcon />}
        sx={!project ? { color: "#777" } : {}}
      >
        <StyledTypography>
          {project || "Select Project"}
        </StyledTypography>
      </Button>
      <Popper
        open={isOpen}
        anchorEl={addProductRef.current}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <Grow {...TransitionProps} timeout={350}>
              <Paper elevation={5}>
                <Controller
                  control={control}
                  name="project"
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={
                        (projects?.data || [])?.map(({ name }) => name) || []
                      }
                      size="small"
                      onChange={(event, value) => field.onChange(value)}
                      sx={{ width: 400 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project"
                          disabled={isLoadingProjectList}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <Fragment>
                                {isLoadingProjectList ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  )}
                />
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </Fragment>
  );
};
